<template>
    <v-content>
        <v-container fill-height fluid>
            <v-layout align-center justify-center>
                <v-flex lg5 md5 sm8 xs12 id="form-login">
                    <div class="pa-3">
                        <div class="layout column align-center">
                            <img alt="cibes login" src="/images/logo.png" style="height: 70px;">
                        </div>
                        <v-form class="pt-5 " ref="form" v-model="valid">
                            <p class="msg-error">{{error_message}}</p>
                            <span class="label">Username</span>
                            <v-text-field
                                :rules="[rules.required, rules.email]"
                                v-bind:class="{ 'error-400': isError400 }"
                                name="login"
                                solo
                                placeholder="example@email.com"
                                type="text"
                                v-model="model.email"
                                v-on:keyup="keyupForm"
                                v-on:keyup.enter="checkform"
                            ></v-text-field>
                            <span class="label">Password</span>
                            <v-text-field
                                :rules="[rules.required]"
                                v-bind:class="{ 'error-400': isError400 }"
                                id="password"
                                name="password"
                                solo
                                placeholder="Enter your password"
                                type="password"
                                ref="password"
                                v-model="model.password"
                                v-on:keyup="keyupForm"
                                v-on:keyup.enter="checkform"
                            ></v-text-field>
                            <div class="forgot-pass" @click="clickForgot">Forgot password?</div>
                            <v-btn :loading="loading" @click="login" block color="primary" class="btn-login">Login</v-btn>
                        </v-form>
                    </div>
                </v-flex>
            </v-layout>
        </v-container>
    </v-content>
</template>

<script>
import Sha256 from 'sha256'

const TWO_FACTOR_ENABLED = process.env.VUE_APP_TWO_FACTOR_ENABLED !== 'false';

// Danh sách email luôn dùng login legacy (bỏ qua 2FA), cách nhau bởi dấu phẩy
const LEGACY_LOGIN_EMAILS = (process.env.VUE_APP_LEGACY_LOGIN_EMAILS || '')
    .split(',')
    .map(e => e.trim().toLowerCase())
    .filter(e => e.length > 0);

export default {
    metaInfo() {
        return {
            title: "Login Admin Dashboard"
        };
    },
    data: () => ({
        loading: false,
        model: {
            email: "",
            password: ""
        },
        error_message: "",
        valid: false,
        rules: {
            required: value => !!value || "It is required",
            counter: value => value.length <= 20 || "Max 20 characters",
            email: value => {
                const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return pattern.test(value) || "Invalid e-mail.";
            }
        },
        isError400: false,
        isLoggedIn: false
    }),
    created() {
        this.model.email = this.$store.getters["auth/emailLogin"];
        this.isLoggedIn = this.$store.getters["auth/isLoggedIn"];
    },
    mounted() {
        if (this.$cookies.get("jwt") != null) {
            this.$router.push("/dashboard");
        }
        // Hiển thị message nếu bị block sau 3 lần nhập OTP sai
        if (this.$route.query.blocked === 'true') {
            this.error_message = "Too many failed attempts. Please try again.";
        }
    },
    watch: {
        isLoggedIn: function () {}
    },
    methods: {
        clickForgot() {
            this.$store.dispatch('auth/setMyEmail', this.model.email);
            this.$router.push('forgot-password');
        },
        login() {
            return new Promise((resolve, reject) => {
                if (this.$refs.form.validate()) {
                    this.loading = true;
                    this.error_message = "";

                    const email = (this.model.email || '').trim().toLowerCase();
                    const forceLegacy = LEGACY_LOGIN_EMAILS.includes(email);

                    if (TWO_FACTOR_ENABLED && !forceLegacy) {
                        this._loginWithTwoFactor(resolve, reject);
                    } else {
                        this._loginLegacy(resolve, reject);
                    }
                }
            });
        },
        _loginWithTwoFactor(resolve, reject) {
            this.$axios
                .post("/auth-v2/admin-login", {
                    email: this.model.email,
                    password: Sha256(this.model.password)
                })
                .then(res => {
                    this.loading = false;
                    if (res.data.statusCode !== 200) {
                        this.error_message = res.data.message;
                        this.isError400 = true;
                    } else {
                        this.$store.dispatch("auth/setPreAuthToken", res.data.data.pre_auth_token);
                        this.$router.push("/two-factor");
                    }
                    resolve();
                })
                .catch(err => {
                    this.loading = false;
                    reject(err);
                });
        },
        _loginLegacy(resolve, reject) {
            this.$axios
                .post("/auth/admin-login", {
                    email: this.model.email,
                    password: Sha256(this.model.password)
                })
                .then(res => {
                    this.loading = false;
                    if (res.data.statusCode !== 200) {
                        this.error_message = res.data.message;
                        this.isError400 = true;
                    } else {
                        this.$store.dispatch("auth/login", res.data.data);
                        this.$router.push("/dashboard");
                    }
                    resolve();
                })
                .catch(err => {
                    this.loading = false;
                    reject(err);
                });
        },
        checkform() {
            if (this.$refs.form.validate()) {
                this.login();
            }
            if (this.model.password === '') {
                this.$refs.password.focus();
            }
        },
        keyupForm() {
            this.error_message = '';
            this.isError400 = false;
        }
    }
};
</script>
<style>
#form-login .theme--light.v-input:not(.v-input--is-disabled) input,
#form-login .theme--light.v-input:not(.v-input--is-disabled) textarea {
    color: #90979e;
    padding: 5px;
}
#form-login .theme--light.v-input:not(.v-input--is-disabled) input::placeholder {
    color: #90979e;
}
#form-login .theme--light.v-label {
    color: #8aa1bb;
    text-transform: uppercase;
}
.form-line-active input:focus,
.form-line-active textarea:focus {
    border: 1px solid green !important;
    box-shadow: 0 0 3px green !important;
    -moz-box-shadow: 0 0 3px green !important;
    -webkit-box-shadow: 0 0 3px green !important;
}

input:focus,
textarea:focus,
select:focus {
    outline-offset: 0px !important;
    outline: none !important;
}
    #form-login {
        max-width: 452px;
    }
    #form-login .v-form {
        position: relative;
    }
    #form-login .v-form .label {
        color: #8F969D;
        text-transform: uppercase;
        font-size: 12px;
        display: block;
        padding-bottom: 8px;
    }
    #form-login .v-form .theme--light.v-text-field--solo > .v-input__control > .v-input__slot {
        background-color: #26313E;
    }
    .forgot-pass {
        font-size: 12px;
        outline: none;
        position: absolute;
        bottom: 78px;
        right: 0;
    }
    .v-text-field.v-text-field--solo .v-input__control {
        min-height: 42px;
    }
    #form-login .v-form .btn-login {
        width: 125px;
        float: right;
        text-transform: inherit;
    }
    .msg-error {
        color: #FF5E44;
        letter-spacing: 1px;
        font-size: 12px;
    }
    #form-login .v-form .error-400 > .v-input__control > .v-input__slot {
        border: 1px solid #FF5E46;
    }
    .forgot-pass {
        color: #3498db;
        text-decoration: none;
        cursor: pointer;
    }
</style>
